<template>
  <div>
    <div class="gray-bg">
      <main-header/>
    </div>
    <div v-if="isLoaded">
      <div v-if="moreProducts.length === 0">
        <v-alert
            text
            type="error"
        >
          محصولی یافت نشد
        </v-alert>
      </div>
      <more-products v-else :productsArray="moreProducts" :page-title="this.categoryName"/>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import MainHeader from "./mainHeader";
import MoreProducts from "./moreProducts";

export default {
  name: "categoryProducts",
  metaInfo() {
    return {
      title: window.projectName + this.categoryName,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.categoryName,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.categoryName,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {MainHeader, MoreProducts},
  data: () => ({
    moreProducts: [],
    isLoaded: false,
    showLoaderDialog: false,
    categoryName: ""
  }),
  mounted() {
    _this = this
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("CategoryID", this.$route.query.categoryId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/SearchEngine/ShowProductByCategoryID", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.moreProducts = json;

            if (json.length > 0) {
              this.categoryName = json[0].CategoryName;
            }
            this.isLoaded = true
            this.showLoaderDialog = false

          })
          .catch(error => console.log('error', error));
    }
  },
  watch: {
    '$route.query.categoryId'() {
      this.getData();
    }
  },

}
</script>

<style scoped>

</style>
